export default "__VITE_ASSET__DExwsNV___"